/* LIPSELL — arrow buttons for the homepage horizontal card scrollers.
   Additive: native scroll still works (drag/trackpad) if this never runs. */
(function () {
  var CHEVRON = {
    prev: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  function makeArrow(dir, list) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'card-scroll-arrow card-scroll-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
    b.innerHTML = CHEVRON[dir];
    b.addEventListener('click', function () {
      var card = list.querySelector('.product-card');
      var gap = parseFloat(getComputedStyle(list).columnGap) || 20;
      var step = card ? card.getBoundingClientRect().width + gap : list.clientWidth;
      var perPage = Math.max(1, Math.round(list.clientWidth / step));
      list.scrollBy({ left: perPage * step * (dir === 'prev' ? -1 : 1), behavior: 'smooth' });
    });
    return b;
  }

  function initOne(list) {
    if (!list || list.dataset.lsScroller === '1') return;
    var scroller = list.closest('.scroller');
    if (!scroller) return;
    list.dataset.lsScroller = '1';

    var prev = makeArrow('prev', list);
    var next = makeArrow('next', list);
    var track = document.createElement('div'); track.className = 'card-scroll-track';
    var thumb = document.createElement('div'); thumb.className = 'card-scroll-thumb';
    track.appendChild(thumb);
    var nav = document.createElement('div');
    nav.className = 'card-scroll-nav';
    nav.appendChild(prev);
    nav.appendChild(track);
    nav.appendChild(next);
    /* place the control cluster (‹ ▬▬ ›) on the right of the section header, above the cards */
    var section = list.closest('.shopify-section') || list.closest('section');
    var header = section && section.querySelector('.section__header');
    (header || scroller).appendChild(nav);

    function update() {
      var maxScroll = list.scrollWidth - list.clientWidth - 2;
      if (maxScroll <= 0) { nav.hidden = true; return; }
      nav.hidden = false;
      prev.disabled = list.scrollLeft <= 8;
      next.disabled = list.scrollLeft >= maxScroll;
      /* thumb width = portion of the row visible; left = how far through we've scrolled */
      var widthPct = Math.max(22, (list.clientWidth / list.scrollWidth) * 100);
      var progress = Math.min(1, Math.max(0, list.scrollLeft / maxScroll));
      thumb.style.width = widthPct + '%';
      thumb.style.left = (progress * (100 - widthPct)) + '%';
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    requestAnimationFrame(update);
    setTimeout(update, 400);
    update();
  }

  function init() {
    document.querySelectorAll('.scroller__inner .product-list--scrollable').forEach(initOne);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  /* Re-init after product-recommendations AJAX swap (Warehouse swaps innerHTML with no event) */
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      document.querySelectorAll('.scroller__inner .product-list--scrollable').forEach(initOne);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Variant swatch carousel: arrow prev/next navigation (reuses card-scroll-* CSS) */
(function () {
  var CHEVRON = {
    prev: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function makeArrow(dir, carousel) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'card-scroll-arrow card-scroll-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
    b.innerHTML = CHEVRON[dir];
    b.addEventListener('click', function () {
      var cards = Array.prototype.slice.call(carousel.querySelectorAll('.carousel-item'));
      if (!cards.length) return;
      if (dir === 'next') {
        var viewRight = carousel.scrollLeft + carousel.clientWidth;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft + 10 > viewRight) {
            carousel.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
            return;
          }
        }
      } else {
        var targetLeft = Math.max(0, carousel.scrollLeft - carousel.clientWidth);
        var nearest = 0;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft <= targetLeft + 2) nearest = cards[i].offsetLeft;
        }
        carousel.scrollTo({ left: nearest, behavior: 'smooth' });
      }
    });
    return b;
  }

  function initOne(carousel) {
    if (!carousel || carousel.dataset.lsVariant === '1') return;
    var swatchList = carousel.closest('.variant-swatch-list');
    if (!swatchList) return;
    var optionSpan = swatchList.previousElementSibling;
    if (!optionSpan) return;
    carousel.dataset.lsVariant = '1';

    var prev = makeArrow('prev', carousel);
    var next = makeArrow('next', carousel);
    var track = document.createElement('div'); track.className = 'card-scroll-track';
    var thumb = document.createElement('div'); thumb.className = 'card-scroll-thumb';
    track.appendChild(thumb);
    var nav = document.createElement('div');
    nav.className = 'card-scroll-nav';
    nav.appendChild(prev);
    nav.appendChild(track);
    nav.appendChild(next);

    var headerWrap = document.createElement('div');
    headerWrap.className = 'variant-carousel-header';
    swatchList.parentNode.insertBefore(headerWrap, optionSpan);
    headerWrap.appendChild(optionSpan);
    headerWrap.appendChild(nav);

    function update() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
      if (maxScroll <= 0) { nav.hidden = true; return; }
      nav.hidden = false;
      prev.disabled = carousel.scrollLeft <= 8;
      next.disabled = carousel.scrollLeft >= maxScroll;
      var widthPct = Math.max(22, (carousel.clientWidth / carousel.scrollWidth) * 100);
      var progress = Math.min(1, Math.max(0, carousel.scrollLeft / maxScroll));
      thumb.style.width = widthPct + '%';
      thumb.style.left = (progress * (100 - widthPct)) + '%';
    }

    carousel.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    requestAnimationFrame(update);
    update();
  }

  function init() {
    document.querySelectorAll('.variant-swatch-list .carousel').forEach(initOne);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Gallery dots + arrows navigation */
(function () {
  var CHEVRON = {
    prev: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function init() {
    var scroller = document.querySelector('.template-product .product-gallery .scroller');
    if (!scroller || scroller.dataset.lsGallery === '1') return;
    scroller.dataset.lsGallery = '1';

    var list = scroller.querySelector('.product-gallery__thumbnail-list');
    if (!list) return;

    function getVisible() {
      return Array.from(list.querySelectorAll('.product-gallery__thumbnail:not(.single_dot):not(.is-filtered)'));
    }
    function getCurrent() {
      return list.querySelector('.product-gallery__thumbnail.is-nav-selected');
    }

    var wrap = document.createElement('div');
    wrap.className = 'ls-gallery-nav';
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'card-scroll-arrow card-scroll-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON.prev;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'card-scroll-arrow card-scroll-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON.next;

    // Build footer: counter on left, arrows+track on right
    var footer = document.createElement('div');
    footer.className = 'ls-gallery-footer';

    var counter = document.createElement('span');
    counter.className = 'ls-gallery-counter';

    var track = document.createElement('div'); track.className = 'card-scroll-track';
    var thumb = document.createElement('div'); thumb.className = 'card-scroll-thumb';
    track.appendChild(thumb);

    wrap.appendChild(prev);
    wrap.appendChild(track);
    wrap.appendChild(next);

    footer.appendChild(counter);
    footer.appendChild(wrap);

    var carouselWrapper = scroller.closest('.product-gallery') && scroller.closest('.product-gallery').querySelector('.product-gallery__carousel-wrapper');
    if (carouselWrapper) {
      carouselWrapper.appendChild(footer);
    } else {
      scroller.parentNode.insertBefore(footer, scroller);
    }
    // Keep list hidden in DOM so theme JS can still trigger thumbnail clicks
    list.style.display = 'none';
    scroller.style.display = 'none';

    function update() {
      var visible = getVisible();
      var current = getCurrent();
      var idx = visible.indexOf(current);
      var total = visible.length;
      footer.style.display = total <= 1 ? 'none' : '';
      counter.textContent = (idx + 1) + ' / ' + total + ' ' + ((window.languages && window.languages.galleryPhotos) || 'photos');
      prev.disabled = idx <= 0;
      next.disabled = idx >= total - 1;
      var widthPct = Math.round(100 / total);
      var leftPct = total > 1 ? Math.round((idx / (total - 1)) * (100 - widthPct)) : 0;
      thumb.style.width = widthPct + '%';
      thumb.style.left = leftPct + '%';
    }

    prev.addEventListener('click', function () {
      var visible = getVisible();
      var idx = visible.indexOf(getCurrent());
      if (idx > 0) visible[idx - 1].click();
    });
    next.addEventListener('click', function () {
      var visible = getVisible();
      var idx = visible.indexOf(getCurrent());
      if (idx < visible.length - 1) visible[idx + 1].click();
    });

    var mo = new MutationObserver(update);
    list.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
      mo.observe(t, { attributes: true, attributeFilter: ['class'] });
    });
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Sync product-form SKU → gallery mobile SKU on variant change */
(function () {
  function init() {
    var formSku = document.querySelector('.product-form .product-meta__sku');
    var gallerySku = document.querySelector('.product-meta__sku--gallery');
    var formNum = formSku && formSku.querySelector('.product-meta__sku-number');
    var galleryNum = gallerySku && gallerySku.querySelector('.product-meta__sku-number--gallery');
    if (!formSku || !gallerySku || !formNum || !galleryNum) return;
    function sync() {
      galleryNum.textContent = formNum.textContent;
      gallerySku.style.display = formSku.style.display;
    }
    sync();
    new MutationObserver(sync).observe(formSku, { attributes: true, subtree: true, childList: true, characterData: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Fix ingredient tables: strip inline backgrounds from headers, enforce row borders */
(function () {
  function fixIngredientTables() {
    document.querySelectorAll('.rte table').forEach(function (table) {
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      rows.forEach(function (row, i) {
        if (row.classList.contains('category-header')) {
          row.querySelectorAll('td, th').forEach(function (cell) {
            cell.style.removeProperty('background-color');
            cell.style.removeProperty('background');
          });
          row.style.setProperty('border-bottom', '1px solid #e0e1e3', 'important');
          return;
        }
        row.querySelectorAll('td, th').forEach(function (cell) {
          cell.style.setProperty('border-bottom', '1px solid #e0e1e3', 'important');
        });
      });
    });
  }
  if (document.readyState !== 'loading') fixIngredientTables();
  else document.addEventListener('DOMContentLoaded', fixIngredientTables);
})();

/* Sold-out variant: grey price badge, show 0 quantity, disable buttons, enforce inventory max */
(function () {
  function getQtyInput() { return document.querySelector('.quantity-selector--product [name="quantity"]'); }
  function getBtn(action) { return document.querySelector('[data-action="' + action + '-picker-quantity"]'); }

  function updateButtonStates(input, soldOut) {
    var minus = getBtn('decrease');
    var plus  = getBtn('increase');
    if (!minus || !plus) return;
    if (soldOut) { minus.disabled = true; plus.disabled = true; return; }
    var val = parseInt(input.value, 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10);
    minus.disabled = val <= 1;
    plus.disabled  = !isNaN(max) && val >= max;
  }

  function syncVariantState() {
    var checked = document.querySelector('.variant-swatch__radio:checked, .block-swatch__radio:checked');
    var item = checked ? checked.closest('.carousel-item') : null;
    var soldOut = !!(item && item.classList.contains('sold-out'));

    var price = document.querySelector('.main-price');
    if (price) price.classList.toggle('is-sold-out', soldOut);

    var input = getQtyInput();
    if (!input) return;

    if (soldOut) {
      input.value = 0;
      input.setAttribute('max', 0);
    } else if (item) {
      var inv     = parseInt(item.getAttribute('data-inventory'), 10);
      var policy  = item.getAttribute('data-inventory-policy');
      var managed = item.getAttribute('data-inventory-management');
      if (managed && managed !== 'false' && policy !== 'continue' && inv > 0) {
        input.setAttribute('max', inv);
        if ((parseInt(input.value, 10) || 0) > inv) input.value = inv;
      } else {
        input.removeAttribute('max');
      }
      input.value = 1;
    }

    updateButtonStates(input, soldOut);
  }

  function isCurrentlyOOS() {
    var checked = document.querySelector('.variant-swatch__radio:checked, .block-swatch__radio:checked');
    var item = checked ? checked.closest('.carousel-item') : null;
    return !!(item && item.classList.contains('sold-out'));
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('.variant-swatch__radio, .block-swatch__radio')) {
      syncVariantState();
    } else if (e.target.matches('.quantity-selector--product [name="quantity"]')) {
      var max = parseInt(e.target.getAttribute('max'), 10);
      if (!isNaN(max)) e.target.value = Math.min(max, Math.max(1, parseInt(e.target.value, 10) || 1));
      updateButtonStates(e.target, false);
    }
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target.matches('.quantity-selector--product [name="quantity"]')) return;
    var input = e.target;
    setTimeout(function () {
      if (isCurrentlyOOS()) { input.value = 0; updateButtonStates(input, true); }
    }, 0);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-action="increase-picker-quantity"]') &&
        !e.target.closest('[data-action="decrease-picker-quantity"]')) return;
    var input = getQtyInput();
    if (!input) return;
    setTimeout(function () {
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && (parseInt(input.value, 10) || 1) > max) input.value = max;
      updateButtonStates(input, false);
    }, 0);
  });

  if (document.readyState !== 'loading') syncVariantState();
  else document.addEventListener('DOMContentLoaded', syncVariantState);
  window.addEventListener('load', function () { setTimeout(syncVariantState, 50); });
})();

/* In-grid size/capacity variant switching (like the colour swatches) — no navigation */
(function () {
  document.addEventListener('click', function (e) {
    var box = e.target.closest('.product-card .size-box');
    if (!box) return;
    e.preventDefault();
    if (box.classList.contains('sold-out')) return;

    var card = box.closest('.product-card');
    var group = box.closest('.grid-size-options');
    if (!card || !group) return;

    group.querySelectorAll('.size-box').forEach(function (b) { b.classList.remove('is-selected'); });
    box.classList.add('is-selected');

    var price = box.getAttribute('data-price');
    if (price) { var p = card.querySelector('.price--highlight'); if (p) p.textContent = price; }

    var rrp = box.getAttribute('data-rrp');
    if (rrp) { var r = card.querySelector('.rrp__amount'); if (r) r.textContent = rrp; }

    var img = box.getAttribute('data-image');
    var mediaId = box.getAttribute('data-media-id');
    if (img && mediaId) {
      var imgEl = card.querySelector('.product-item__primary-image');
      if (imgEl && imgEl.getAttribute('data-media-id') !== mediaId) {
        imgEl.setAttribute('src', img); imgEl.setAttribute('srcset', '');
        imgEl.setAttribute('data-media-id', mediaId);
      }
    }

    var url = box.getAttribute('data-variant-url');
    if (url) card.querySelectorAll('a.product-item__title, a.product-item__image-wrapper').forEach(function (a) { a.setAttribute('href', url); });
  });
})();

/* Size-variant footer overflow: show the sizes that fit + a "+N" chip for the rest */
(function () {
  function fit(group) {
    var old = group.querySelector('.size-more');
    if (old) old.remove();
    var boxes = Array.prototype.slice.call(group.querySelectorAll('.size-box'));
    boxes.forEach(function (b) { b.style.display = ''; });
    /* sort smallest -> largest by the leading number (e.g. 100ml < 250ml < 1000ml) and reorder in the DOM */
    boxes.sort(function (a, b) { return (parseFloat(a.textContent) || 0) - (parseFloat(b.textContent) || 0); });
    boxes.forEach(function (b) { group.appendChild(b); });
    if (boxes.length < 2) return;

    var cs = getComputedStyle(group);
    var avail = group.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (avail <= 0) return;
    var gap = parseFloat(cs.columnGap || cs.gap) || 5;

    var widths = boxes.map(function (b) { return b.offsetWidth; });
    var total = widths.reduce(function (a, w) { return a + w; }, 0) + gap * (boxes.length - 1);
    if (total <= avail) return; // they all fit — no chip

    var chipW = 32; // approx width of the "+N" chip + leading gap
    var used = 0, fitCount = 0;
    for (var i = 0; i < boxes.length; i++) {
      var add = widths[i] + (i > 0 ? gap : 0);
      if (used + add + gap + chipW > avail) break;
      used += add; fitCount++;
    }
    if (fitCount < 1) fitCount = 1;
    for (var j = fitCount; j < boxes.length; j++) boxes[j].style.display = 'none';

    var card = group.closest('.product-card');
    var chip = document.createElement('a');
    chip.className = 'size-more';
    chip.textContent = '+' + (boxes.length - fitCount);
    var tl = card && card.querySelector('a.product-card__title');
    if (tl) chip.setAttribute('href', tl.getAttribute('href'));
    group.appendChild(chip);
  }
  function run() { document.querySelectorAll('.product-card .grid-size-options').forEach(fit); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('ls:cards', run); /* cross-sell kortelės įdėtos JS'u (ls-cross-sell.js) */
})();

/* Category chip strip: drag-to-scroll for mouse/trackpad (touch keeps native swipe) + edge fades */
(function () {
  function init(strip) {
    if (strip.dataset.lsCat === '1') return;
    strip.dataset.lsCat = '1';
    var section = strip.closest('.cat-strip-section') || strip;

    function fades() {
      var max = strip.scrollWidth - strip.clientWidth;
      section.classList.toggle('cat-overflow', max > 2);
      section.classList.toggle('cat-at-start', strip.scrollLeft <= 2);
      section.classList.toggle('cat-at-end', strip.scrollLeft >= max - 2);
    }
    strip.addEventListener('scroll', fades, { passive: true });
    window.addEventListener('resize', fades);
    window.addEventListener('load', fades);
    fades();

    var down = false, startX = 0, startScroll = 0, moved = 0, capturedId = null;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;        /* touch scrolls natively */
      if (strip.scrollWidth <= strip.clientWidth + 2) return;         /* nothing to drag */
      down = true; moved = 0; startX = e.clientX; startScroll = strip.scrollLeft;
      capturedId = e.pointerId;
      /* Capture lazily in pointermove — capturing here redirects mousedown/click to the
         strip element, which breaks <a> link navigation on simple clicks. */
    });
    strip.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      if (moved > 4 && capturedId !== null && !strip.hasPointerCapture(capturedId)) {
        strip.setPointerCapture(capturedId);
        strip.classList.add('is-dragging');
      }
      strip.scrollLeft = startScroll - dx;
    });
    function end() { if (down) { down = false; capturedId = null; strip.classList.remove('is-dragging'); } }
    strip.addEventListener('pointerup', end);
    strip.addEventListener('pointercancel', end);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
    strip.addEventListener('click', function (e) {                    /* it was a drag, not a tap → don't navigate */
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  function run() { document.querySelectorAll('.cat-strip').forEach(init); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* Sticky mobile CTA bar — quantity + add-to-cart + wishlist */
(function () {
  function init() {
    var form = document.querySelector('.template-product .product-form');
    if (!form || form.dataset.lsSticky === '1') return;
    form.dataset.lsSticky = '1';

    var origQty   = form.querySelector('.quantity-selector--product');
    var origInput = origQty && origQty.querySelector('input[name="quantity"]');
    var origMinus = origQty && origQty.querySelector('[data-action="decrease-picker-quantity"]');
    var origPlus  = origQty && origQty.querySelector('[data-action="increase-picker-quantity"]');
    var origAtc   = form.querySelector('.product-form__add-button');
    var origBis   = form.querySelector('.back-in-stock__trigger');
    var origWish  = document.querySelector('.wishlist-btn--product');

    var bar = document.createElement('div');
    bar.className = 'ls-sticky-cta';

    /* quantity */
    var qtyDiv = document.createElement('div');
    qtyDiv.className = 'ls-sticky-qty';
    var btnMinus = document.createElement('button');
    btnMinus.type = 'button'; btnMinus.className = 'ls-sticky-qty-btn';
    btnMinus.setAttribute('aria-label', 'Decrease');
    btnMinus.innerHTML = '<svg viewBox="0 0 10 2" width="10" height="10"><path d="M10 0v2H0V0z" fill="currentColor"/></svg>';
    var qtySpan = document.createElement('span'); qtySpan.className = 'ls-sticky-qty-val';
    var btnPlus = document.createElement('button');
    btnPlus.type = 'button'; btnPlus.className = 'ls-sticky-qty-btn';
    btnPlus.setAttribute('aria-label', 'Increase');
    btnPlus.innerHTML = '<svg viewBox="0 0 10 10" width="10" height="10"><path d="M6 0v4h4v2H6v4H4V6H0V4h4V0z" fill="currentColor"/></svg>';
    qtyDiv.appendChild(btnMinus); qtyDiv.appendChild(qtySpan); qtyDiv.appendChild(btnPlus);

    /* cta */
    var ctaBtn = document.createElement('button');
    ctaBtn.type = 'button'; ctaBtn.className = 'ls-sticky-cta-btn';

    /* wishlist */
    var wishBtn = null;
    if (origWish) {
      wishBtn = document.createElement('button');
      wishBtn.type = 'button'; wishBtn.className = 'ls-sticky-wish';
      wishBtn.setAttribute('aria-label', 'Wishlist');
      wishBtn.innerHTML = '<svg viewBox="0 0 24.9 21.3" xmlns="http://www.w3.org/2000/svg"><path class="st0" d="M12.1,7c0-2.7,2.2-4.9,4.9-4.9c5.1,0,5.1,5.3,5.1,5.3c0,7.7-10,11.8-10,11.8c0,0-10-4.1-10-11.8c0,0,0-5.3,5.1-5.3C9.9,2.2,12.1,4.3,12.1,7"/></svg>';
    }

    bar.appendChild(qtyDiv); bar.appendChild(ctaBtn);
    if (wishBtn) bar.appendChild(wishBtn);
    document.body.appendChild(bar);

    function syncQty() {
      qtySpan.textContent = origInput ? origInput.value : '1';
      if (origMinus) btnMinus.disabled = origMinus.disabled;
    }

    function getActiveBtn() {
      // ATC disabled = OOS; use BIS trigger in that case
      if (origAtc && !origAtc.disabled) return origAtc;
      if (origBis) return origBis;
      return origAtc;
    }

    function syncCta() {
      var btn = getActiveBtn();
      if (!btn) return;
      if (btn === origBis) {
        ctaBtn.innerHTML = btn.innerHTML;
      } else {
        ctaBtn.textContent = btn.textContent.trim();
      }
      ctaBtn.disabled = btn.disabled;
      ctaBtn.classList.toggle('is-sold-out', btn.classList.contains('is-sold-out'));
      ctaBtn.classList.toggle('ls-sticky-cta-btn--bis', btn === origBis);
    }

    function syncWish() {
      if (!origWish || !wishBtn) return;
      wishBtn.classList.toggle('is-active', origWish.classList.contains('wishlist-btn--active'));
    }

    syncQty(); syncCta(); syncWish();

    btnMinus.addEventListener('click', function () {
      if (origMinus) origMinus.click(); setTimeout(syncQty, 60);
    });
    btnPlus.addEventListener('click', function () {
      if (origPlus) origPlus.click(); setTimeout(syncQty, 60);
    });
    var toast = document.createElement('div');
    toast.id = 'ls-atc-toast';
    var toastDefaultText = '✓ ' + ((window.languages && window.languages.productAddedShort) || 'Pridėta');
    toast.textContent = toastDefaultText;
    document.body.appendChild(toast);
    var toastTimer;
    function showToast(msg) {
      clearTimeout(toastTimer);
      toast.textContent = msg || toastDefaultText;
      toast.classList.add('is-visible');
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.textContent = toastDefaultText; }, 250);
      }, 2500);
    }

    var adding = false;
    var atcReq = 0;
    ctaBtn.addEventListener('click', function () {
      var btn = getActiveBtn();
      if (!btn) return;

      if (btn === origBis) {
        origBis.click();
        return;
      }

      // Direct AJAX add — don't call origAtc.click() because programmatic
      // click() on a hidden button doesn't reliably bubble through Warehouse's
      // event-delegation handler on iOS Safari.
      var atcForm = origAtc && origAtc.closest('form[action*="/cart/add"]');
      if (!atcForm) { origAtc.click(); return; }

      // Prefer the hidden input over the Warehouse master <select> (both named "id")
      var variantInput = atcForm.querySelector('input[type="hidden"][name="id"]')
                      || atcForm.querySelector('[name="id"]');
      if (!variantInput) return;

      var variantId = parseInt(variantInput.value, 10);
      if (!variantId) return;

      var qty = origInput ? (parseInt(origInput.value, 10) || 1) : 1;

      var myReq = ++atcReq;
      adding = true;
      ctaBtn.disabled = true;

      function onRerendered() { adding = false; syncCta(); showToast(); }
      document.addEventListener('cart:rerendered', onRerendered, { once: true });

      var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function (r) {
        if (r.ok) {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: qty }
          }));
        } else {
          r.json().then(function (err) {
            if (myReq !== atcReq) return;
            adding = false;
            document.removeEventListener('cart:rerendered', onRerendered);
            syncCta();
            showToast((window.languages && window.languages.cartMaxQuantity) || 'Daugiau pridėti negalima');
          }).catch(function () {
            if (myReq !== atcReq) return;
            adding = false;
            document.removeEventListener('cart:rerendered', onRerendered);
            syncCta();
          });
        }
      }).catch(function () {
        if (myReq !== atcReq) return;
        adding = false;
        document.removeEventListener('cart:rerendered', onRerendered);
        syncCta();
      });
    });
    if (wishBtn) wishBtn.addEventListener('click', function () { if (origWish) origWish.click(); });

    new MutationObserver(function () { syncQty(); if (!adding) syncCta(); syncWish(); })
      .observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style', 'class', 'value'] });
    if (origWish) new MutationObserver(syncWish).observe(origWish, { attributes: true, childList: true, subtree: true });
    if (origInput) origInput.addEventListener('change', syncQty);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
